import { inject, Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@jsverse/transloco';

@Injectable()
export class SpanishPaginatorIntl extends MatPaginatorIntl {
  private transloco = inject(TranslocoService);
  override itemsPerPageLabel = this.transloco.translate(
    'PAGINATOR.ELEMENTS-PER-PAGE',
  );
  override nextPageLabel = this.transloco.translate('PAGINATOR.NEXT-PAGE');
  override previousPageLabel = this.transloco.translate(
    'PAGINATOR.PREVIOUS-PAGE',
  );
  override firstPageLabel = this.transloco.translate('PAGINATOR.FIRST-PAGE');
  override lastPageLabel = this.transloco.translate('PAGINATOR.LAST-PAGE');

  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return this.transloco.translate('PAGINATOR.RANGE-EMPTY', { length });
    }
    return this.transloco.translate('PAGINATOR.RANGE', {
      start: page * pageSize + 1,
      end: Math.min((page + 1) * pageSize, length),
      length,
    });
  };
}
